import React, { useRef } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";

import { createBrowserHistory } from "history";

import { Redirect } from "react-router-dom";

import { useStateWithCallback } from "../utils/useStateWithCallback";
import CustomErrors from "../features/CustomErrors";
import * as Constants from "./Constants";

const baseUrl = Constants.URL();

function Login() {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    watch,
  } = useForm();

  const password = useRef({});
  password.current = watch("password", "");

  const history = createBrowserHistory();

  const [post, setPost] = React.useState(null);
  const [isValid, setIsValid] = useStateWithCallback(true);
  const [urlRedirect, seturlRedirect] = React.useState(null);
  const toastId = React.useRef(null);

  const [toggle, setToggle] = React.useState(false);
  const [invalidEmail, setInvalidEmail] = React.useState(null);
  const [email, setEmail] = React.useState("");
  const [apiErrors, setApiErrors] = React.useState([]);

  let showFailedMessage = false;

  function emailValidation() {
    const regex =
      '/^(([^<>()[].,;:s@"]+(.[^<>()[].,;:s@"]+)*)|(".+"))@(([^<>()[].,;:s@"]+.)+[^<>()[].,;:s@"]{2,})$/i';
    if (!email || regex.test(email) === false) {
      setInvalidEmail("Email is not valid");
      return false;
    }
    return true;
  }

  function onChange(e) {
    setEmail(e.target.value);
    emailValidation();
  }

  const onSubmit = function (data) {
    var login = {
      email: data.email,
      password: data.password,
      rememberMe: data.remember,
    };
    setApiErrors([]);
    <CustomErrors Code="" Description="" />;

    axios
      .post(`${baseUrl}Auth/Login`, login)
      .then((response) => {
        setPost(response.data);

        console.log(response.data);

        if (response.data.Succeeded == true) {
          if (!toast.isActive(toastId.current)) {
            toastId.current = toast.success("Submitted Successfully", {
              toastId: "success",
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: false,
              draggable: false,
              progress: undefined,
              theme: "light",
              draggablePercent: 0,
            });
          }
          const location = {
            pathname: `/Newsletters`,
            state: { fromDashboard: true },
          };

          history.push(location);

          setTimeout(() => window.location.reload(), 3500);
        } else {
          var error = {
            Code: "IncorrectPassword",
            Description: "Incorrect email or password combination",
          };

          setApiErrors([error]);

          console.log(apiErrors);
        }
      })
      .catch((err) => {
        console.error(err);

        var error = {
          Code: "NotAdmin",
          Description: "You are not an Administrator",
        };

        setApiErrors([error]);
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error("Submission failed", {
            toastId: "failed",
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: false,
            draggable: false,
            progress: undefined,
            theme: "light",
            draggablePercent: 0,
          });
        }
      });
  };

  return (
    <div className="Card u-marginAuto u-marginBottom20">
      <div className="Card-content u-marginTop10">
        <form onSubmit={handleSubmit(onSubmit)}>
          <input
            className="customInput"
            type="hidden"
            name="csrfmiddlewaretoken"
            value="0aiY5RDRupxjz3ITP49uNZ3YYfET3oeBn3RewbVyTP1JNRJIwc6YRdCACn9UbrQr"
          />
          <h2 className="Card-title u-marginBottom20">
            Login to Vulekamali Newsletter
          </h2>
          <p>
            <label htmlFor="email">Email address:</label>
            <input
              className="customInput"
              type="email"
              name="email"
              autoFocus="autoFocus"
              onChange={onChange}
              {...register("email", { required: true })}
              id="id_email"
            />
          </p>
          {errors.email && errors.email.type === "required" && (
            <span className="required">Email address is required</span>
          )}
          <p>
            <label htmlFor="password">Password:</label>
            <input
              className="customInput"
              type="password"
              name="password"
              autoFocus="autoFocus"
              {...register("password", { required: true })}
              id="id_password"
            />
          </p>
          {errors.password && errors.password.type === "required" && (
            <span className="required">Password is required</span>
          )}
          <p>
            <label htmlFor="remember">Remember Me</label>
            <input
              type="checkbox"
              name="remember"
              {...register("remember", { required: false })}
              id="id_rememberMe"
            />
          </p>

          {apiErrors &&
            apiErrors.map((data) => (
              <CustomErrors Code={data.Code} Description={data.Description} />
            ))}

          <input
            type="Submit"
            className="Button"
            //</form>onClick={handleSubmit(onSubmit)}>

            //</div></button> /
          />
        </form>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <ToastContainer />
    </div>
  );
}

export default withRouter(Login);
